import { DialogTitle, IconButton, Typography, useTheme } from '@mui/material';
import { Close } from '@mui/icons-material';
import React from 'react';
import { ModalContext } from './ModalContext';

export interface ModalHeaderProperties {
  children?: React.ReactNode;
}

function ModalHeader({ children }: Readonly<ModalHeaderProperties>) {
  const { requestClose } = React.useContext(ModalContext);
  const theme = useTheme();

  return (
    <DialogTitle
      sx={{
        m: 0,
        px: 3,
        py: 2.5,
        background: `linear-gradient(135deg, ${theme.palette.primary.main}15 0%, ${theme.palette.primary.dark}08 100%)`,
        borderBottom: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography
        variant="h6"
        component="div"
        fontWeight={600}
        sx={{ color: 'text.primary' }}
      >
        {children}
      </Typography>
      <IconButton
        onClick={requestClose}
        size="small"
        data-testid="modal-close-button"
        sx={{
          color: 'text.secondary',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        <Close />
      </IconButton>
    </DialogTitle>
  );
}

export default ModalHeader;
